import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from '@chakra-ui/react'
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './context/UserContext';
import { AlertProvider } from './context/AlertContext';
import { ReloadProvider } from './context/ReloadContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <BrowserRouter>

 {/* <React.StrictMode> */}
  
    <ChakraProvider>
      <AlertProvider>
    <UserProvider>
    <ReloadProvider>
      <App />
      </ReloadProvider> 
    </UserProvider>
    </AlertProvider>
    </ChakraProvider>
 {/* </React.StrictMode> */}
  </BrowserRouter>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
